import { useTranslation } from 'react-i18next';
import {
  KoobActionsFooter,
  KoobButton,
  KoobButtonSplit,
  KoobMenuItem,
  KoobTooltip,
} from '@koob/ui';
import { useHasUnsavedChanges } from '@koob/trip-designer';

// Why the book button is off: the first reason that applies, else the trip is
// simply not complete.
const getBookTip = (availability, t) => {
  if (availability.hasUnavailableExperience) {
    return t('compose.hasUnavailableProgram');
  }
  if (availability.hasUnavailableHotel) {
    return t('compose.hasUnavailableHotel');
  }
  if (availability.isAvailabilityPending) {
    return t('compose.availabilityLoading');
  }
  return t('compose.missingDays');
};

// Save as draft (or as a template) and book.
export default function ComposeMapFooter({
  saving,
  finalizing,
  isLoading,
  isTripComplete,
  canSaveAsTemplate,
  hasCurrencyMismatch,
  availability,
  onSaveDraft,
  onSaveTemplate,
  onBook,
}) {
  const { t } = useTranslation('tripDesigner');
  const hasUnsavedChanges = useHasUnsavedChanges();

  return (
    <KoobActionsFooter>
      <KoobButtonSplit
        block
        onClick={onSaveDraft}
        loading={saving || finalizing}
        disabled={isLoading}
        primaryDisabled={!hasUnsavedChanges}
        primaryTip={
          hasUnsavedChanges ? undefined : t('compose.noChangesToSave')
        }
        testId="btn-draft-save"
        menuLabel={t('compose.saveAsTemplate')}
        menuTestId="btn-template-save-menu"
        menu={
          <KoobTooltip
            tip={
              !canSaveAsTemplate
                ? t('compose.alreadySavedAsTemplate')
                : t('compose.missingDays')
            }
            disabled={isTripComplete}
            position="top"
          >
            <KoobMenuItem
              icon="fa-light fa-bookmark"
              onClick={onSaveTemplate}
              disabled={!isTripComplete || isLoading}
              data-testid="btn-template-save"
            >
              {t('compose.saveAsTemplate')}
            </KoobMenuItem>
          </KoobTooltip>
        }
      >
        {t('compose.saveAsDraft')}
      </KoobButtonSplit>
      <KoobTooltip
        tip={getBookTip(availability, t)}
        position="left"
        block
        disabled={isTripComplete && !availability.hasUnbookableProduct}
      >
        <KoobButton
          block
          variant="primary"
          loading={saving || finalizing}
          disabled={
            !isTripComplete ||
            isLoading ||
            hasCurrencyMismatch ||
            availability.hasUnbookableProduct
          }
          onClick={onBook}
        >
          {t('compose.bookThisTrip')}
        </KoobButton>
      </KoobTooltip>
    </KoobActionsFooter>
  );
}
